import { render, staticRenderFns } from "./RegisterAgency.vue?vue&type=template&id=264f05af&scoped=true"
import script from "./RegisterAgency.vue?vue&type=script&lang=js"
export * from "./RegisterAgency.vue?vue&type=script&lang=js"
import style0 from "./RegisterAgency.vue?vue&type=style&index=0&id=264f05af&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264f05af",
  null
  
)

export default component.exports